import { render, staticRenderFns } from "./AnnotationGraphic.vue?vue&type=template&id=685b983a&scoped=true&"
import script from "./AnnotationGraphic.vue?vue&type=script&lang=js&"
export * from "./AnnotationGraphic.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationGraphic.vue?vue&type=style&index=0&id=685b983a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b983a",
  null
  
)

export default component.exports